var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEverProEllipseMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 157,
    viewBox: "0 0 178 157",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: -33.436,
    cy: 41.34,
    rx: 110.564,
    ry: 114.756,
    fill: "#FFB301",
    fillOpacity: 0.4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M177.736 5.18398C177.736 67.6938 127.062 118.368 64.5522 118.368C2.04237 118.368 -48.6318 67.6938 -48.6318 5.18398C-48.6318 -57.3258 2.04237 -108 64.5522 -108C127.062 -108 177.736 -57.3258 177.736 5.18398Z",
    fill: "#FFB301",
    fillOpacity: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEverProEllipseMobile);
export default __webpack_public_path__ + "static/media/everPro_ellipse_mobile.c5ae0e87fe71f871183a1fb976dd0ad2.svg";
export { ForwardRef as ReactComponent };